<!-- <div class="loading">Loading&#8230;</div> -->

<!-- <div class="loader">
	<div class="circle"></div>
</div> -->

<!-- <span class="loader">
	<span class="loader-inner"></span>
</span> -->


<div class="theme-loader">
	<div class="cm-spinner"></div>
</div>